





















exports.default =
  props: ['task']

  methods:
    destroyTask: ->
      Loader.on()
      new TasksResource().destroy(@destroyTaskSuccess, @unknownError, {id: @task.id})

    destroyTaskSuccess: (resource) ->
      @$emit 'destroyed', { task: @task, event: resource.body.task.event }
      Loader.off()



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/confirm_destroy.vue